import { DealType } from '../../../../listing'
import { CostArgs } from '../../../utils'
import { CanadaPurchaseTaxes } from '../purchase-taxes'
import { HST } from './expense'

export const OntarioPurchaseTaxes = (args: CostArgs) => ({
  ...CanadaPurchaseTaxes,
  ...([DealType.NEW, DealType.PRECON].includes(args.dealType) ? { HST } : undefined),
})
